var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIconCropped(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "9.5 9.5 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5 47.5C85.5 68.4868 68.4868 85.5 47.5 85.5C26.5132 85.5 9.5 68.4868 9.5 47.5C9.5 26.5132 26.5132 9.5 47.5 9.5C68.4868 9.5 85.5 26.5132 85.5 47.5ZM57 33.25C57 38.4967 52.7467 42.75 47.5 42.75C42.2533 42.75 38 38.4967 38 33.25C38 28.0033 42.2533 23.75 47.5 23.75C52.7467 23.75 57 28.0033 57 33.25ZM47.4997 52.25C37.9164 52.25 29.6587 57.926 25.9052 66.0997C31.1316 72.1622 38.8676 76 47.4999 76C56.1321 76 63.8679 72.1623 69.0943 66.1C65.3409 57.9262 57.0831 52.25 47.4997 52.25Z",
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconCropped);
export default __webpack_public_path__ + "static/media/profileIcon-cropped.ecb1abdb52acd2b1d3ebb1605cde8610.svg";
export { ForwardRef as ReactComponent };